<template>
  <div class="serial-code-create">
    <div class="dialog-content">
      <div class="mb-x2" layout layout-align="space-between-start">
        <el-button type="default" @click="changeTab('serial-code-table')"
          ><i class="mdi mdi-keyboard-backspace"></i>戻る</el-button
        >
      </div>
      <!-- 対象メッセージ-->
      <div class="input-container mb-x2">
        <div class="label">対象メッセージ</div>
        <el-select v-model="messageId" placeholder="対象メッセージ" :disabled="isEdit">
          <el-option :value="null" label="全てのメッセージ"></el-option>
          <el-option
            v-for="(message, index) in messages"
            :value="message.id"
            :label="message.name"
            :key="index"
          ></el-option>
        </el-select>
      </div>
      <div class="message message-error mb-x2">
        未割り当てのシリアルコードを全て削除してよろしいですか?<br />この操作は取り消しできません。
      </div>
    </div>
    <div class="dialog-footer" slot="footer">
      <div layout layout-align="space-between-start">
        <div></div>
        <el-button type="primary" @click="deleteSerialCode"
          ><i class="mdi mdi-playlist-play"></i>一括削除を実行</el-button
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import api from '@/client/core/api'
import { useTwitterInstantwinMessageStore } from '@/client/store/useTwitterInstantwinMessageStore'
import { useTwitterInstantwinSerialCodeStore } from '@/client/store/useTwitterInstantwinSerialCodeStore'

export default defineComponent({
  data() {
    return {
      messageId: null as number | null,
      isSubmit: false
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(useTwitterInstantwinSerialCodeStore, {
      currentMessageId: state => state.messageId,
      campaignId: state => state.campaignId
    }),
    ...mapState(useTwitterInstantwinMessageStore, {
      messages: state => state.messages.filter(message => message.messageType === 'win')
    })
  },
  created() {
    if (this.isEdit) {
      this.messageId = this.currentMessageId
    }
  },
  methods: {
    ...mapActions(useTwitterInstantwinSerialCodeStore, ['fetchSerialCodeList']),
    ...mapActions(useTwitterInstantwinMessageStore, ['fetchInstantwinMessages']),

    /**
     * Change screen
     * @param {string} tab
     */
    changeTab(tab: string) {
      this.$emit('change_tab', tab)
    },

    /**
     * Resets serial code
     */
    deleteSerialCode() {
      if (this.isSubmit) return
      this.postButton({
        campaignId: this.campaignId,
        messageId: this.messageId
      })
    },

    /**
     * 未割り当てコードの削除
     * @param {Object} params 送信データ
     */
    async postButton(params: any) {
      this.isSubmit = true

      const response = await api.post(`/twitter_instantwin_serial_codes/resets`, params)

      setTimeout(() => {
        this.isSubmit = false
      }, 2000)

      if (response.data) {
        const title = 'シリアルコードを削除しました。'

        this.$notify({
          title,
          message: '',
          customClass: 'success',
          duration: 5000
        })

        this.changeTab('serial-code-table')
        await this.fetchInstantwinMessages()
        return
      }

      this.$notify({
        title: 'シリアルコードの削除に失敗しました。',
        message: '恐れ入りますが、時間をおいて再度お試しください。',
        customClass: 'danger',
        duration: 5000
      })
    }
  }
})
</script>
